import { create } from 'zustand'

interface StoreStatus {
    store_id: string
    store_status: number
}

interface StoreState {
    stores: StoreStatus[]
    setStoreStatus: (store_id: string, store_status: number) => void
    getStoreStatus: (store_id: string) => number | undefined
}

export const useStoreStatusStore = create<StoreState>((set, get) => ({
    stores: [],
    setStoreStatus: (store_id, store_status) => {
        set((state) => {
            const existingStore = state.stores.find((store) => store.store_id === store_id)
            if (existingStore) {
                return {
                    stores: state.stores.map((store) => (store.store_id === store_id ? { ...store, store_status } : store)),
                }
            } else {
                return {
                    stores: [...state.stores, { store_id, store_status }],
                }
            }
        })
    },
    getStoreStatus: (store_id) => {
        const store = get().stores.find((store) => store.store_id === store_id)
        return store ? store.store_status : undefined
    },
}))
